module.exports = __webpack_public_path__ + "advisory-8c397925/das-ultimative-handbuch-fuer-empfeh-bc75c8f73298fbdcddc6791559824c24.jpeg";